// TODO: convert this to hook

import _ from 'lodash';
import moment from 'moment';
import {formatEventTime} from '../../../../data/hooks/datetimeHooks';
import {dialogConfirm} from '../../../elements/Dialog/dialogs';

async function confirmCancellation(event, i18n, programItem) {
    var msg = i18n['message.overlapping-choice']
        .replace('{2}', programItem.name)
        .replace('{0:HH:mm}', formatEventTime(event, programItem.start_local))
        .replace('{1:HH:mm}', formatEventTime(event, programItem.end_local));
    return dialogConfirm(msg);
}

export default async function (i18n, eventId, programItem, otherSelections, callbacks) {
    callbacks = Object.assign({}, callbacks, {
        onStart: _.identity,
        onSuccess: _.identity,
        onError: _.identity,
        onEnd: _.identity,
    });

    let state = app.store.getState(),
        event = state.events[eventId].event,
        indexedItems = state.events[eventId].schedule.indexed,
        overlaps = _([programItem.id, ...otherSelections])
            .map(questionId => indexedItems[questionId])
            .compact()
            .map(programItem => {
                let range1 = moment.range(moment(programItem.start), moment(programItem.end));
                return _(otherSelections)
                    .filter(item => {
                        let range2 = moment.range(moment(item.start), moment(item.end));
                        return range1.overlaps(range2);
                    })
                    .value();
            })
            .flatten()
            .value();

    if (
        !overlaps.length ||
        (await Promise.all(overlaps.map(item => confirmCancellation(event, i18n, item)))).find(confirmation => confirmation)
        // !_(overlaps).find(item => {
        //     return !confirmCancellation(event, i18n, item);
        // })
    ) {
        callbacks.onStart();
        app.store.dispatch(app.actions.ui.busy());
        overlaps = overlaps.map(item => item.id);
        app.api.events
            .programItemSelection(eventId, programItem.id, true)
            .then(() => {
                callbacks.onSuccess();
            })
            .catch(error => {
                app.store.dispatch(app.actions.program.updateProgramSelection(eventId, overlaps, [programItem.id]));
                error = _(error).get('response.data', {});
                callbacks.onError(error);
                app.api.events.fetchProgram(eventId);
            })
            .then(() => {
                app.store.dispatch(app.actions.ui.free());
                callbacks.onEnd();
            });
    }
}
